import { EPresentationCategories } from '@/domains/investor/const/PresentationCategories.enum'
import type { IInvestorPresentationBreadcrumbs, IInvestorPresentationTab } from '@/domains/investor/types/investor.types'

export const usePresentations = () => {
  const { t } = useI18n()

  const tabs = computed<IInvestorPresentationTab[]>(() => [
    {
      label: t('investor.stock.presentations.tabs.presentation'),
      slotName: EPresentationCategories.PRESENTATION,
      requestId: 'investor-centrum-wynikow-prezentacje-wynikowe',
    },
    {
      label: t('investor.stock.presentations.tabs.strategy'),
      slotName: EPresentationCategories.STRATEGY,
      requestId: 'investor-centrum-wynikow-strategia-spolki',
    },
    {
      label: t('investor.stock.presentations.tabs.other'),
      slotName: EPresentationCategories.OTHER,
      requestId: 'inne-prezentacje',
    },
  ])

  const selectedTab = ref<IInvestorPresentationTab>(tabs.value[0]!)
  const activatedTabs = ref<Partial<Record<EPresentationCategories, boolean>>>({
    [EPresentationCategories.PRESENTATION]: true,
    [EPresentationCategories.STRATEGY]: false,
    [EPresentationCategories.OTHER]: false,
  })

  const mainCategory = computed<IInvestorPresentationBreadcrumbs['mainCategory']>(() => ({
    label: t('investor.stock.presentations.mainCategory.label'),
    url: t('investor.stock.presentations.mainCategory.url'),
    aria: t('investor.stock.presentations.mainCategory.aria'),
  }))

  const secondCategory = computed<IInvestorPresentationBreadcrumbs['secondCategory']>(() => ({
    label: t('investor.stock.presentations.secondCategory.label'),
    url: t('investor.stock.presentations.secondCategory.url'),
    aria: t('investor.stock.presentations.secondCategory.aria'),
  }))

  const changeTab = (tab: IInvestorPresentationTab) => {
    selectedTab.value = tab
  }

  const isTabActivated = (tabName: EPresentationCategories) => !!activatedTabs.value[tabName]

  watch(selectedTab, (tab) => {
    activatedTabs.value[tab.slotName] = true
  }, { immediate: true })

  return {
    tabs,
    selectedTab,
    mainCategory,
    secondCategory,
    changeTab,
    isTabActivated,
    presentationRequestId: tabs.value[0]?.requestId ?? '',
    strategyRequestId: tabs.value[1]?.requestId ?? '',
    otherRequestId: tabs.value[2]?.requestId ?? '',
  }
}
